import RolesListList from '../../../../components/Main/Group/Roles/RolesListList'
import RolesListModal from '../../../../components/Main/Group/Roles/RolesListModal'
import React, { Component, Fragment } from 'react'

function RolesList(props) {
  return (
    <Fragment>
      <RolesListModal {...props} />
      <RolesListList {...props} />
    </Fragment>
  )
}

RolesList.propTypes = {}
RolesList.defaultProps = {}

export default RolesList
